import styled from 'styled-components'

export const HeaderContainer = styled.div`
    width:100%;

  .adm-nav-bar-title{
    overflow:visible;
  }
  .top-nav-bar{
    position: relative;
    background-color: #36BEF1;
    //color: #FFF;
    //color: #FFF;

  }
    .rightBtn{
            width:70px;
            height:30px;
            font-size:14px;
            background:#36BEF1;
            display:flex;
            justify-content:center;
            align-items:center;
            border-radius:25px;
        }

    &>.topBox{
        position: fixed;
        top:0;
        width:100%;
        z-index:99;

        
    }

`
